<template>

</template>

<script>
export default {
	name: "f_files"
}
</script>

<style scoped>

</style>
